export default "__VITE_ASSET__4af3e0a5__"